import { ProductDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockDto } from "./stock.dto";


export class AllStockResponseModel extends GlobalResponseObject {
    data?: StockDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: StockDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 